import React from "react";
import FinalResponseList from "./List";

const FinalResponse = () => {
  return (
    <div>
      <FinalResponseList />
    </div>
  );
};

export default FinalResponse;
